import readXlsxFile from 'read-excel-file'
import moment from 'moment'
export const parseExcelMixin = {
  methods: {
    parseExcelFile (event) {
      readXlsxFile(event.srcElement.files[0]).then((rows) => {
        console.log(rows)
        // Поручение
        this.$refs.commissionPage[0].commissionForm.DocumentNumber = rows[0][4]

        this.$refs.commissionPage[0].commissionForm.BorderCustomCode = rows[1][3]
        this.$refs.commissionPage[0].$refs['BorderCustomCode'].model = this.$refs.commissionPage[0].commissionForm.BorderCustomCode

        this.$refs.commissionPage[0].commissionForm.BorderCustomsOfficeName = rows[1][4]
        this.$refs.commissionPage[0].$refs['BorderCustomsOfficeName'].model = this.$refs.commissionPage[0].commissionForm.BorderCustomsOfficeName

        this.$refs.commissionPage[0].commissionForm.DocumentDate = moment(new Date(rows[22][2])).format('YYYY-MM-DDTHH:mm:ss.sssZ')
        this.$refs.commissionPage[0].$refs['DocumentDate'].model = this.$refs.commissionPage[0].commissionForm.DocumentDate

        const CarrierName = rows[6].slice()
        CarrierName.shift()
        this.$refs.commissionPage[0].commissionForm.Carrier_Name = CarrierName.join(' ').trim()

        const ShipmentDateIndex = rows[4].findIndex((item) => {
          return item === 'Дата погрузки:'
        })
        const ConsignorName = rows[4].slice().splice(0, ShipmentDateIndex)
        ConsignorName.shift()
        this.$refs.commissionPage[0].commissionForm.Consignor_Name = ConsignorName.join(' ').trim()

        let ShipmentDate = rows[4].slice().splice(ShipmentDateIndex, rows[4].length - 1)
        ShipmentDate.shift()

        const ContractIndex = rows[5].findIndex((item) => {
          return item === 'Контракт:'
        })
        const ConsigneeName = rows[5].slice().splice(0, ContractIndex)
        ConsigneeName.shift()
        this.$refs.commissionPage[0].commissionForm.Consignee_Name = ConsigneeName.join(' ').trim()

        const ImoIndex = rows[2].findIndex((item) => {
          return item === 'Номер ИМО судна:'
        })
        let VesselName = rows[2].slice().splice(0, ImoIndex)
        VesselName.shift()
        VesselName = VesselName.join(' ').trim()

        const FlagIndex = rows[2].findIndex((item) => {
          return item === 'Флаг судна:'
        })
        let Imo = rows[2].slice().splice(ImoIndex, (FlagIndex - ImoIndex))
        Imo.shift()
        Imo = Imo.join(' ').trim()

        let VesselNationality = rows[2].slice().splice(FlagIndex, rows[2].length - 1)
        VesselNationality.shift()
        this.$refs.commissionPage[0].commissionForm.VesselNationality = VesselNationality.join(' ').trim()
        this.$refs.commissionPage[0].$refs['VesselNationality'].model = this.$refs.commissionPage[0].commissionForm.VesselNationality

        this.loadNsiCountries(this.$refs.commissionPage[0].commissionForm.VesselNationality).then(
          () => {
            this.$refs.commissionPage[0].commissionForm.VesselNationalityCode = this.nsiCountries[0].abc2
            this.$refs.commissionPage[0].$refs['VesselNationalityCode'].model = this.$refs.commissionPage[0].commissionForm.VesselNationalityCode
            this.$nextTick(() => {
              this.setNsiCountries(null)
            })
          },
          (error) => {
            console.log(error)
          }
        )

        this.$refs.commissionPage[0].commissionForm.VesselName = VesselName + ' IMO ' + Imo
        this.$refs.commissionPage[0].commissionForm.IMO = Imo

        const LoadingPlaceIndex = rows[3].findIndex((item) => {
          return item === 'Место погрузки в порту:'
        })
        let LoadingPort = rows[3].slice().splice(0, LoadingPlaceIndex)
        LoadingPort.shift()
        LoadingPort = LoadingPort.join(' ').trim()

        if (LoadingPort.match(/^[A-Za-z-`']+$/)) {
          this.loadNsiPorts({ param: 'port_eng', value: LoadingPort }).then(
            () => {
              this.$refs.commissionPage[0].commissionForm.LoadingCode = this.nsiPorts[0].port_code
              this.$refs.commissionPage[0].$refs['LoadingCode'].model = this.$refs.commissionPage[0].commissionForm.LoadingCode
              this.$nextTick(() => {
                this.setNsiPorts(null)
              })
            },
            (error) => {
              console.log(error)
            }
          )
        }
        if (LoadingPort.match(/^[А-Яа-я-`']+$/)) {
          this.loadNsiPorts({ param: 'port_rus', value: LoadingPort }).then(
            () => {
              this.$refs.commissionPage[0].commissionForm.LoadingCode = this.nsiPorts[0].port_code
              this.$refs.commissionPage[0].$refs['LoadingCode'].model = this.$refs.commissionPage[0].commissionForm.LoadingCode
              this.$nextTick(() => {
                this.setNsiPorts(null)
              })
            },
            (error) => {
              console.log(error)
            }
          )
        }

        const DestinationPortIndex = rows[3].findIndex((item) => {
          return item === 'Порт назначения:'
        })
        let LoadingPlace = rows[3].slice().splice(LoadingPlaceIndex, (DestinationPortIndex - LoadingPlaceIndex))
        LoadingPlace.shift()
        LoadingPlace = LoadingPlace.join(' ').trim()

        let DestinationPort = rows[3].slice().splice(DestinationPortIndex, rows[3].length - 1)
        DestinationPort.shift()
        this.$refs.commissionPage[0].commissionForm.UnloadingName = DestinationPort[0]
        this.$refs.commissionPage[0].$refs['UnloadingName'].model = this.$refs.commissionPage[0].commissionForm.UnloadingName

        ShipmentDate = moment(new Date(ShipmentDate)).format('DD.MM.YYYY')
        this.$refs.commissionPage[0].commissionForm.LoadingName = LoadingPort + ' ' + LoadingPlace + ' ' + ShipmentDate
        this.$refs.commissionPage[0].$refs['LoadingName'].model = this.$refs.commissionPage[0].commissionForm.LoadingName

        this.$refs.commissionPage[0].commissionForm.DocSig_PersonName = rows[21][2]

        this.$refs.commissionPage[0].commissionForm.DocSig_IssueDate = moment(new Date(rows[22][2])).format('YYYY-MM-DDTHH:mm:ss.sssZ')
        this.$refs.commissionPage[0].$refs['DocSig_IssueDate'].model = this.$refs.commissionPage[0].commissionForm.DocSig_IssueDate

        let Forwarder = rows[16][0]
        this.$refs.commissionPage[0].commissionForm.Forwarder = Forwarder.trim()

        // Товары
        let goods = []
        for (let i = 0; i < rows.length; i++) {
          if (/(^\d{8}[/](((0[1-9]|1[0-9]|2[0-8])(0[1-9]|1[012]))|((29|30|31)(0[13578]|1[02]))|((29|30)(0[4,6,9]|11)))\d{2}[/]{1}[0-9A-Za-zА-Яа-я]{1,7}$)|(^\d{8}[/]2902\d{2}[/]{1}[0-9A-Za-zА-Яа-я]{1,7}$)/.test(rows[i][0])) {
            goods.push({
              GTDID: rows[i][0],
              GoodsNumericDT: rows[i][2],
              GoodsDescription: rows[i][5],
              GoodsCode: rows[i][3],
              NetWeightQuantity: rows[i][4],
              WarehouseName: this.$refs.commissionPage[0].commissionForm.Carrier_Name,
              Procedure: null,
              CodeProcedure: null,
              GrossWeightQuantity: null,
              WeightTare: null,
              GrossTareWeightQuantity: null,
              SupplementaryGoodsQuantity: null,
              MeasureUnitQualifierCode: null,
              MeasureUnitQualifierName: null,
              Dimensions: null,
              VolumeQuantity: null,
              EmptyAllContainer: false,
              COMMISSIONSHIPMENTPlaces: {
                COMMISSIONSHIPMENTPLACES_ITEM: [
                  {
                    PlacesQuantity: null, // Кол-во грузовых мест
                    PlacesDescription: null, // Описание вида грузовых мест (коробок, упаковок, паллет и т.д.)
                    PlacesCode: null, // Код вида грузовых мест
                    WeightPackage: null // Вес одного грузового места (поддон, паллета и т.д)
                  }
                ]
              },
              COMMISSIONSHIPMENTContainer: {
                COMMISSIONSHIPMENTCONTAINER_ITEM: [
                  {
                    ContainerID: null, // Номер контейнера
                    ContainerKind: null, // Тип контейнера
                    WeightTare: null, // Вес тары
                    GrossTareWeight: null, // Вес гросс (кг)
                    SealId: null // Номер пломбы
                  }
                ]
              },
              COMMISSIONSHIPMENTDocument: {
                COMMISSIONSHIPMENTDOCUMENT_ITEM: [
                  {
                    ModeCode: null, // Вид документа
                    DocumentName: null, // Наименование документа
                    DocumentNumber: null, // Номер документа
                    DocumentDate: null // Дата документа
                  }
                ]
              },
              COMMISSIONSHIPMENTDanger: {
                COMMISSIONSHIPMENTDANGER_ITEM: [
                  {
                    UNNO: null, // Код UNNO
                    DangerIMO: null // Груз: класс опасности IMO
                  }
                ]
              }
            })
          }
        }
        this.$refs.goodsPage[0].COMMISSIONSHIPMENTGoods.COMMISSIONSHIPMENTGOODS_ITEM = goods
        this.$refs.goodsPage[0].GoodsDescription = '-'
      })
    }
  }
}
